import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import classNames from 'classnames';
const VALID_MENU_ITEM_ROLES = new Set(['menuitem', 'menuitemcheckbox', 'menuitemradio']);
export function MenuItemPrimitive({ ref, className, children, role = 'menuitem', asChild = false, disabled, onSelect, textValue, ...props }) {
    const shouldShowFocusRing = !VALID_MENU_ITEM_ROLES.has(role);
    const itemClassName = classNames('reset flex', {
        interactable: shouldShowFocusRing,
        'pointer-events-none': disabled,
    }, className);
    return (_jsx(DropdownMenuPrimitive.Item, { ref: ref, disabled: disabled, onSelect: onSelect, textValue: textValue, asChild: asChild, className: itemClassName, ...(asChild ? {} : { role }), ...props, children: children }));
}
//# sourceMappingURL=MenuItemPrimitive.js.map